export default class Suggestion {
  constructor() {
    this.id = null;
    this.body = null;
    this.category = null;
  }
}
